(function () {
  if (window.__collectionInfiniteScroll) return;
  window.__collectionInfiniteScroll = true;

  var DEBUG = true; // set to false once it works
  function log() {
    if (DEBUG) console.log.apply(console, ['[infinite-scroll]'].concat([].slice.call(arguments)));
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) { log('ProductGridContainer not found'); return; }

    var style = document.createElement('style');
    style.textContent =
      '#ProductGridContainer.is-infinite .pagination-wrapper{display:none}' +
      '.infinite-scroll-loader{display:none;justify-content:center;padding:2rem 0}' +
      '.infinite-scroll-loader.is-visible{display:flex}' +
      '.infinite-scroll-loader__spinner{width:3rem;height:3rem;border:3px solid rgba(var(--color-foreground),.2);' +
      'border-top-color:rgb(var(--color-foreground));border-radius:50%;animation:infinite-scroll-spin .8s linear infinite}' +
      '@keyframes infinite-scroll-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);

    var loader = document.createElement('div');
    loader.className = 'infinite-scroll-loader page-width';
    loader.setAttribute('role', 'status');
    loader.innerHTML =
      '<div class="infinite-scroll-loader__spinner" aria-hidden="true"></div>' +
      '<span class="visually-hidden">Loading more products</span>';
    container.insertAdjacentElement('afterend', loader);

    var state = { gen: 0, page: 1, nextUrl: null, loading: false };

    function getGrid() { return document.getElementById('product-grid'); }

    function pageOf(href) {
      try {
        var p = parseInt(new URL(href, window.location.href).searchParams.get('page'), 10);
        return isNaN(p) ? 1 : p;
      } catch (e) { return 1; }
    }

    // Find the pagination link that points to `page` inside `root`
    function findPageUrl(root, page) {
      var links = root.querySelectorAll('.pagination__list a[href], .pagination-wrapper a[href]');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href');
        if (pageOf(href) === page) return new URL(href, window.location.href).toString();
      }
      return null;
    }

    function reset() {
      state.gen++;
      state.loading = false;
      loader.classList.remove('is-visible');
      state.page = pageOf(window.location.href);
      state.nextUrl = findPageUrl(container, state.page + 1);
      log('reset', { page: state.page, nextUrl: state.nextUrl });
      check();
    }

    function check() {
      var grid = getGrid();
      if (!grid || !state.nextUrl || state.loading) return;
      if (grid.getBoundingClientRect().bottom < window.innerHeight + 800) loadNext();
    }

    function loadNext() {
      var grid = getGrid();
      if (!grid || !state.nextUrl || state.loading) return;

      state.loading = true;
      loader.classList.add('is-visible');
      var gen = state.gen;
      var requestUrl = state.nextUrl;
      log('fetching', requestUrl);

      fetch(requestUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('Request failed: ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (gen !== state.gen) { log('stale response discarded'); return; }

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('#product-grid > .grid__item');
          var currentGrid = getGrid();
          if (!currentGrid) return;
          log('received items', newItems.length);

          var fragment = document.createDocumentFragment();
          newItems.forEach(function (li, i) {
            li.style.setProperty('--animation-order', i + 1);
            fragment.appendChild(document.importNode(li, true));
          });
          currentGrid.appendChild(fragment);

          state.page++;
          state.nextUrl = newItems.length ? findPageUrl(doc, state.page + 1) : null;
          if (newItems.length) container.classList.add('is-infinite');
          log('next url', state.nextUrl);
        })
        .catch(function (e) {
          console.error('[infinite-scroll] error:', e);
          state.nextUrl = null;
          container.classList.remove('is-infinite'); // restore normal pagination
        })
        .finally(function () {
          if (gen !== state.gen) return;
          state.loading = false;
          loader.classList.remove('is-visible');
          check();
        });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; check(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // Dawn's filters/sort replace the container's children
    new MutationObserver(reset).observe(container, { childList: true });

    reset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();